import { render, staticRenderFns } from "./VMenuItem.vue?vue&type=template&id=7f5cd5b9&scoped=true&"
import script from "./VMenuItem.vue?vue&type=script&lang=js&"
export * from "./VMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5cd5b9",
  null
  
)

export default component.exports